/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CartV2AdjustAutoshipMutationInput = {
    readonly autoShipIntervalCount?: number | null;
    readonly autoShipIntervalUnit?: string | null;
    readonly clientMutationId?: string | null;
};
export type CartV2AdjustAutoshipMutationVariables = {
    readonly input: CartV2AdjustAutoshipMutationInput;
};
export type CartV2AdjustAutoshipMutationResponse = {
    readonly cartV2AdjustAutoship: ({
        readonly cartV2: ({
            readonly id: string;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
        }) | null;
    }) | null;
};
export type CartV2AdjustAutoshipMutation = {
    readonly response: CartV2AdjustAutoshipMutationResponse;
    readonly variables: CartV2AdjustAutoshipMutationVariables;
};



/*
mutation CartV2AdjustAutoshipMutation(
  $input: CartV2AdjustAutoshipMutationInput!
) {
  cartV2AdjustAutoship(input: $input) {
    cartV2 {
      id
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartV2AdjustAutoshipMutationInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "cartV2AdjustAutoship",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input",
                    "type": "CartV2AdjustAutoshipMutationInput!"
                }
            ],
            "concreteType": "CartV2AdjustAutoshipMutationPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartV2",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CartV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipEnabled",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipIntervalUnit",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipIntervalCount",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartV2AdjustAutoshipMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "CartV2AdjustAutoshipMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartV2AdjustAutoshipMutation",
            "id": null,
            "text": "mutation CartV2AdjustAutoshipMutation(\n  $input: CartV2AdjustAutoshipMutationInput!\n) {\n  cartV2AdjustAutoship(input: $input) {\n    cartV2 {\n      id\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '23d9992bc10e1a811d7528ecbb77c1e5';
export default node;
